import StandardCategorizedHoldingDocuments from "./standard-categorized-holding-documents";

export default StandardCategorizedHoldingDocuments;
